module.exports = __webpack_public_path__ + "media/3.8d0fb734.mp3";